'use strict';


app.factory('Cart', ['$rootScope', 'Drink', 'Venue', 'Helper', 
    function ($rootScope, Drink, Venue, Helper) {
        var service = {};


        /**
         * get cart total
         *
         * 1. Item price * service type discount = WAAVE price
         * 2. WAAVE price + 10% service charge = Subtotal 1
         * 3. Subtotal 1 + 7% tax = Total
         * 4. Total + Fee = WAAVE total
         */
        service.getTotal = function () {

            // 1. ***************************************************************
            // get drink price
            var drink_price = Drink.getSelectedDrinkPrice();
            var discount = Venue.getDiscount();

            drink_price -= Helper.roundNumber((drink_price * discount/100), 2);
            

            // 2. ***************************************************************
            // get service charge
            var service_charge = $rootScope.globals.selectedVenue.service_charge;
            service_charge = Helper.roundNumber((drink_price * service_charge/100), 2);


            // 3. ***************************************************************
            // get venue tax
            var venue_tax  = Number($rootScope.globals.selectedVenue.tax);
            venue_tax = Helper.roundNumber(((drink_price+service_charge) * venue_tax/100), 2);


            // 4. ***************************************************************
            // get venue service fee
            var venue_fee = Venue.getServiceFee();


            // clculate total
            var total = drink_price + service_charge + venue_tax + venue_fee;


            /*console.log('--------------------------------');
            console.log(drink_price, 'drink_price');
            console.log(venue_tax, 'venue_tax');
            console.log(venue_fee, 'venue_fee');
            console.log(service_charge, 'service_charge');
            console.log(total, 'total');
            console.log('--------------------------------');*/

            return Helper.roundNumber(total, 2);
        };


        /**
         * clear all cart data
         */
        service.clearCart = function(){
            delete $rootScope.globals.selectedUser;
            delete $rootScope.globals.selectedVenue;
            delete $rootScope.globals.selectedDrink;
            delete $rootScope.globals.selectedMoney;
            delete $rootScope.globals.cartData;

            // also delete variables from browsers local storage
            Helper.updateLocalStorageWithGlobalVariable();
        }


        return service;
    }]);